import { render, staticRenderFns } from "./mantenimientos.vue?vue&type=template&id=39b5fff7&scoped=true"
import script from "./mantenimientos.js?vue&type=script&lang=js&external"
export * from "./mantenimientos.js?vue&type=script&lang=js&external"
import style0 from "./manteniminetos.css?vue&type=style&index=0&id=39b5fff7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b5fff7",
  null
  
)

export default component.exports